import { User, StatusTypeCode } from "../models/userModels";

export const getStatusLabel = (status: StatusTypeCode, translate: (key: string) => string): string => {
  switch (status) {
    case StatusTypeCode.active:
      return translate("active");
    case StatusTypeCode.expired:
      return translate("expired");
    case StatusTypeCode.disabled:
      return translate("disabled");
    default:
      return "";
  }
};

export const sortUsers = (users: User[], sortBy: number, sortDesc: boolean): User[] => {
  if (!sortBy) return users;

  const keyMap: { [key: number]: keyof User } = {
    1: "userName",
    2: "department",
    3: "accessType",
    4: "loginDate",
    5: "expirationDate",
    6: "status",
  };

  const key = keyMap[sortBy];
  if (!key) return users;

  return [...users].sort((a, b) => {
    let aValue = a[key];
    let bValue = b[key];

    if (key === "accessType" || key === "status") {
      const aNum = Number(aValue);
      const bNum = Number(bValue);
      if (aNum === bNum) return 0;
      return sortDesc ? bNum - aNum : aNum - bNum;
    }

    if (key === "loginDate" || key === "expirationDate") {
      const aTime = a[key] ? new Date(a[key]!).getTime() : 0;
      const bTime = b[key] ? new Date(b[key]!).getTime() : 0;
      if (aTime === bTime) return 0;
      if (aTime === 0) return 1;
      if (bTime === 0) return -1;
      return sortDesc ? bTime - aTime : aTime - bTime;
    }

    if (aValue === bValue) return 0;
    if (aValue == null) return 1;
    if (bValue == null) return -1;
    if (aValue > bValue) return sortDesc ? -1 : 1;
    if (aValue < bValue) return sortDesc ? 1 : -1;
    return 0;
  });
};

export interface ButtonState {
  regeneratePin: boolean;
  regeneratePinDisabled: boolean;
  disable: boolean;
  activate: boolean;
  delete: boolean;
}

export const getButtonStates = (user: User): ButtonState => {
  const hasLoginDate = !!user.loginDate;
  const isExpired = user.status === StatusTypeCode.expired;
  const isActive = user.status === StatusTypeCode.active;
  const isDisabled = user.status === StatusTypeCode.disabled;

  if (!hasLoginDate && isActive) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: true,
      activate: false,
      delete: true
    };
  }

  if (!hasLoginDate && isExpired) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: false,
      activate: false,
      delete: true
    };
  }

  if (!hasLoginDate && isDisabled) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: false,
      activate: true,
      delete: true
    };
  }

  if (hasLoginDate && isActive) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: true,
      activate: false,
      delete: true
    };
  }

  if (hasLoginDate && isExpired) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: false,
      activate: false,
      delete: true
    };
  }

  if (hasLoginDate && isDisabled) {
    return {
      regeneratePin: true,
      regeneratePinDisabled: false,
      disable: false,
      activate: true,
      delete: true
    };
  }

  return {
    regeneratePin: true,
    regeneratePinDisabled: false,
    disable: false,
    activate: false,
    delete: true
  };
};
